import { useEffect, useState } from "react";
import { BRAND_LOGO } from "@/lib/brandAssets";

export default function SplashScreen({ onDone }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onDone, 400);
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-sidebar transition-opacity duration-400 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <img
        src={BRAND_LOGO}
        alt="TAFitness"
        className="w-48 object-contain animate-pulse"
      />
    </div>
  );
}